/* eslint-disable sort-keys */
export default {
  light: {
    "missing-information-error": "red-1",
    "missing-information-link-gray": "neutral-300",
    "missing-information-link-separator": "neutral-500",
    "missing-information-success": "success-500",
    "password-validation-message": "gray-4",
    "password-validation-message-error": "red-1",
    "password-validation-message-valid": "green-1",
  },
  dark: {
    "missing-information-error": "red-2",
    "missing-information-link-label": "neutral-300",
    "missing-information-link-separator": "neutral-500",
    "missing-information-success": "success-500",
    "password-validation-message": "white",
    "password-validation-message-error": "red-2",
    "password-validation-message-valid": "green-2",
  },
};
